import { render, staticRenderFns } from "./En.vue?vue&type=template&id=54c1bfd0&scoped=true&"
var script = {}
import style0 from "./En.vue?vue&type=style&index=0&id=54c1bfd0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c1bfd0",
  null
  
)

export default component.exports